
import BaseMixin from '@/views/mixin.vue'
import { mapState, mapGetters } from 'vuex'
import { HttpSaLockList, HttpDelSaLock, HttpActiveSaLock } from '@/service/boss/allot';

import compSearch from './search';
import compDetail from './detail';
import compUpdate from './update';

import { Dropdown, Icon, Button } from 'view-design'


export default {
    mixins: [BaseMixin],
    components: {
        compSearch,
        compDetail,
        compUpdate,
    },
    data () {
        return {
            data: [],
            checkedId: [],
        };
    },
    methods: {
        httpList: HttpSaLockList,
        handleOperates (id, type, row) {
            this.operate = {};
            switch (type) {
                case 'edit':
                    this.operate = {
                        id,
                        title: '编辑',
                        component: 'compUpdate',
                        show: true,
                        width: 720,
                        footer: false,
                        type
                    }; break;
                case 'add':
                    this.operate = {
                        id,
                        title: '添加',
                        component: 'compUpdate',
                        show: true,
                        width: 720,
                        footer: false,
                        type
                    }; break;
                case 'query':
                    this.operate = {
                        id,
                        title: '查看',
                        component: 'compDetail',
                        show: true,
                        width: 720,
                        type
                    }; break;
                case 'cancel':
                    this.checkedId = !id ? this.checkedId : [id];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning('请选择至少一条数据');
                        return;
                    }
                    this.showDel = true;
                    this.operate = {
                        title: '取消操作',
                        type
                    }
                    break;
                case 'active':
                    this.checkedId = !id ? this.checkedId : [id];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning('请选择至少一条数据');
                        return;
                    }
                    this.showDel = true;
                    this.operate = {
                        title: '批量激活操作',
                        type,
                    }
                    break;
                case 'upload':
                    this.operate = {
                        show: true,
                        title: '导入数据',
                        data: { contextId: global.SYSID },
                        action: process.env.VUE_APP_APIURL_BOSS + "/api/v2/StockLock/import",
                        name: "excelFile",
                        component: "compUpload",
                        showdownload: true,
                        download: this.download,
                        refresh: this.updateList
                    }
                    break;
            }
        },
        download () {
            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v2/StockTransfer/excel", {}, 'download')
        },
        exportFile (ids) {
            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v2/StockTemplate/export", { ids: ids }, 'download')
        },
        async batchOpearte () {
            let request, { type, id } = this.operate, params = {}, callback = (res) => { this.$Message.success(res.message); };
            switch (type) {
                case 'active': request = HttpActiveSaLock; params = { ids: this.checkedId.join(',') || id }; break;
                case 'cancel': request = HttpDelSaLock; params = { ids: this.checkedId.join(',') || id }; break;
            }
            if (!request) return;
            request(params).then(res => {
                this.$Message.success(res.message);
                this.updateList();
            }, err => {
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            }).finally(result => {
                this.showDel = false;
                this.operate = {};
            });
        },
    },
    computed: {
        ...mapState('boss', ['products']),
        ...mapGetters('boss', ['warehouses']),
        ...mapGetters('diction', ['getNewProductList']),
        columns () {
            return [{
                width: 60,
                type: "selection",
            }, {
                title: "操作",
                width: 180,
                render: (h, { row }) => {
                    const id = row.id, show = row.status !== 'CANCEL';
                    return <div>
                        <Button size='small' type='primary' class='margin-right-5' onClick={this.handleOperates.bind(this, id, 'query')}>查看</Button>
                        <Button v-show={show} size='small' type='success' class='margin-right-5' onClick={this.handleOperates.bind(this, id, 'edit')}>编辑</Button>
                        <Button v-show={show} size='small' type='error' onClick={this.handleOperates.bind(this, id, 'cancel')}>取消</Button>
                    </div>
                }
            },
            {
                title: '#ID',
                width: 80,
                key: 'id',
                sortable: true,
            },
            {
                title: '项目',
                key: 'lineId',
                sortable: true,
                render: (h, { row }) => {
                    const id = row.lineId,
                        result = this.getNewProductList.filter((item) => {
                            return item.value === id;
                        })[0] || {};
                    return <span>{result.label}</span>
                }
            },
            {
                title: '店铺',
                key: 'accountFlag',
            },
            {
                title: "仓库",
                key: "orgWarehouseId",
                render: (h, { row }) => {
                    const id = row.orgWarehouseId,
                        result = this.warehouses.filter((item) => {
                            return item.id === id;
                        })[0] || {};
                    return <span>{result.title}</span>
                }
            },
            {
                title: 'SKU',
                key: 'erpSku',
                sortable: true,
                minWidth: 100,
                render (h, { row }) {
                    return <span>ERPSKU：{row.erpSku}<br />Seller SKU：{row.sellerSku}</span>
                }

            },
            // {
            //     title: 'Seller SKU',
            //     key: 'sellerSku',
            //     sortable: true,
            // }, 
            {
                title: "锁定数量",
                key: "quantity",
                maxWidth: 90,
            },
            // {
            //     title: "处理结果",
            //     width: 90,
            //     key: "dealStatus",
            //     render: (h, { row }) => {
            //         const status = row.dealStatus;
            //         switch (status) {
            //             case 0: return <Button class="cursor-default" type='primary' size='small'>待处理</Button>; break;
            //             case 1: return <Button class="cursor-default" type='success' size='small'>已处理</Button>; break;
            //             case 9: return <Button class="cursor-default" type='error' size='small'>异常</Button>; break;
            //             default: return <Button class="cursor-default" type='primary' size='small'>待处理</Button>; break;
            //         }
            //     }
            // }, 
            {
                title: "锁定时间",
                key: "beginDate",
                render (h, { row }) {
                    return <span>
                        开始时间：{row.beginDate}<br />
                        结束时间：{row.endDate}<br />
                        更新时间：{row.updatedAt}
                    </span>
                }
            },
            // {
            //     title: "更新时间",
            //     key: "updatedAt",

            // }, 
            {
                title: '状态',
                width: 80,
                key: 'status',
                sortable: true,
                render: (h, { row }) => {
                    const status = row.status;
                    switch (status) {
                        case 'ACTIVATE': return <Button class="cursor-default" type='success' size='small'>激活</Button>; break;
                        case 'DRAFT': return <Button class="cursor-default" type='primary' size='small'>草稿</Button>; break;
                        case 'CANCEL': return <Button class="cursor-default" type='error' size='small'>取消</Button>; break;
                        default: return <Button class="cursor-default" type='primary' size='small'>草稿</Button>; break;
                    }
                }
            }];
        },
    },
};




